import axios from 'axios';
import React from 'react';
import HeaderTargetPair from './HeaderTargetPair';
import './index.css';
import { config } from '../../constants'; 
import authHeader from '../../services/auth-header';
import {message, Table} from 'antd';
import HeaderGroup from './HeaderGroup';



export default class ParserControllerContainer extends React.Component{

    constructor(props){
        super(props);
        this.inputRef = React.createRef();
        this.state = {
            testkeys: ["dataURL", "headerRowNumber"],
            configkeys: [

                "name", "source", "shortName", "dataURL", "headerRowNumber", 
                "dataStartingRow", "excludedRowsFromEnd"
            ],
            specialConfigHeaders:{dataListType:["xlsx"]},
            specialHeaderTargets:{recordType:["mixed", "entity", "individual"]},
            headerKeysWithoutGroup: ["recordId", "title", "source"],

            headerGroupConfig: {
                "nameAliases":{keys:["WholeName"], count:0, additionals: {"Type":["name","aka"]}},
                "birthdates":{keys:["Date", "PublicationDate"],count:0},
                "locations":{keys:["WholePlace"], count:0, additionals: {"Type":["placeofbirth", "nationality", "address", "citizenship"]}},
                "identifications":{keys:["Number"], count:0},
                "programs":{keys:["Name"], count:0,},
            },

            headers: [
                {
                    title: 'dummyheader',
                    dataIndex: 'dummyheader',
                    key:"dummyheader,"
                },
            ],

            rowsData:[{
                "dummy":"data"
            }],

            headerTargetsWithoutGroup:["a"],
            headerGroups:{"a":"b"}
        }
    }

    setHeaderGroups = () => {

        const target_groups = document.getElementsByClassName("target-group")
        
        var updated_headerGroupConfig = this.state.headerGroupConfig
        

        target_groups.forEach(group => {
            const header_p = group.getElementsByClassName("header-key-p")[0].innerHTML.slice(0, -6);
            const count_value = Number(group.getElementsByClassName("target-value-input")[0].value);
            updated_headerGroupConfig[header_p].count = count_value
            
        });
        
        this.setState({headerGroupConfig:updated_headerGroupConfig})
    }
    

    addParser = () => {

        var new_parser = {}
        var headerTargets = {}


        const parser_settings_div = document.getElementById("parser-settings")

        const headerPairs =  parser_settings_div.getElementsByClassName("header-target-pair")

        for (const header of headerPairs) {
            const key = header.getElementsByClassName("header-key-p")[0].innerHTML.slice(0,-1);
            const value = header.getElementsByClassName("target-value-input")[0].value.trim()
            new_parser[key] = value
        }

        const items = document.getElementsByClassName("header-target-item")

        for(const item of items){
            const header = item.getElementsByClassName("headerName")[0].innerHTML.trim();
            const target = item.getElementsByClassName("headerTargetValue")[0].value.trim();

            headerTargets[header] = target;
        }

        new_parser["headerTargets"] = JSON.stringify(headerTargets)

        axios.post(config.API_URL + "parser-controller", new_parser, {headers: authHeader()}).then(
            data => {
            window.location.href = "/parser-controller"
        }
        );


    }

    testParser = () =>{

        const testDiv = document.getElementById("test-div");

        const pairs = testDiv.getElementsByClassName("header-target-pair");
        var headerTarget = {}

        for (var i = 0; i<pairs.length; i++){
            var key = pairs[i].getElementsByClassName("header-key-p")[0].innerHTML.slice(0,-1);
            var value = pairs[i].getElementsByClassName("target-value-input")[0].value.trim();

            headerTarget[key] = value
        }

        axios.post(config.API_URL + "parser-overview", headerTarget, {headers: authHeader()}).then(
            response => {
                const headers = response.data.allColumns.map(
                    data => {
                        return {title:data, dataIndex:data, key:data}
                    }
                )
                
                var split_line = {};

                for (var i = 0; i<response.data.allColumns.length;i++){
                    split_line[response.data.allColumns[i]] = "----"
                }
                

                var first5Rows = response.data.first5Rows
                first5Rows.push(split_line)

                var last5Rows = response.data.last5Rows.reverse()

                var table_data = first5Rows.concat(last5Rows)
                
                this.setState({headers: headers, rowsData: table_data})

                const table = document.getElementById("table");
                const parser_settings = document.getElementById("parser-settings")
                
                const options = this.state.headers.map(function(header){
                    return <option value={header.title}>{header.title}</option>
                })

                const headerTargetsWithoutGroup = this.state.headerKeysWithoutGroup.map(
                    function(headerKey){
                        return (
                            <div className='header-target-item'>
                            <p className='headerName'>{headerKey}</p>
                            <select className='headerTargetValue'>
                                {options}
                            </select>
                        </div>
                        )
                })


                this.setState({headerTargetsWithoutGroup:headerTargetsWithoutGroup})

                table.style.display = "block";
                parser_settings.style.display = "block"

            }

        );

    }

    render(){


        const items = this.state.testkeys.map(function(key){
            return <HeaderTargetPair headerKey={key} />
        })


        const configPairs = this.state.configkeys.map(
            function(key){
                return <HeaderTargetPair headerKey={key}/>
            }
        )

        var specialConfigHeaders = []

        for (const key in this.state.specialConfigHeaders) {
            const options = this.state.specialConfigHeaders[key].map(opt => {return <option value={opt}>{opt}</option>})
            specialConfigHeaders.push(<HeaderTargetPair headerKey={key} special="true" options={options}/>)
        }

        const headerGroups = Object.keys(this.state.headerGroupConfig).map(
            key => {
                return <HeaderGroup onValChange={this.setHeaderGroups} options={this.state.headers.map(hdr=>{return hdr.title})} additionals={this.state.headerGroupConfig[key].additionals} headers={this.state.headerGroupConfig[key].keys} header={key} count={this.state.headerGroupConfig[key].count}/>
            }
        )

        var specialHeaderTargets = []

        for (const key in this.state.specialHeaderTargets) {
            const options = this.state.specialHeaderTargets[key].map(opt => {return <option value={opt}>{opt}</option>})
            specialHeaderTargets.push(<div className='header-target-item'>
            <p className='headerName'>{key}</p>
            <select className='headerTargetValue'>
                {options}
            </select>
        </div>)
        }


        return(
            <div className='parser-controller-container' id="parser-controller-container">

                <div id='test-div'>
                    {items}
                </div>

                <button onClick={this.testParser} className="add-parser-button">TEST PARSER</button>

                <Table id="table" columns={this.state.headers} dataSource={this.state.rowsData} pagination={false}/>

                <br/>
                <br/>

                <div id='parser-settings'>
                    {configPairs}
                    {specialConfigHeaders}

                    <br/>

                    {specialHeaderTargets}
                    
                    {this.state.headerTargetsWithoutGroup}
                    

                    {headerGroups}
                    <button onClick={this.addParser} className="add-parser-button">ADD PARSER</button>
                    <br/>
                </div>
            
            </div>
        );
    }
}